import { FC } from 'react'
import { Box, Typography } from '@mui/material'
import { tokens } from '@/theme'

export interface LegendaGraficoProps {
  /** Unidade do eixo/valores ("quantidade de reservas", "R$ — valor estimado"). */
  unidade: string
  /** Período aplicado ao gráfico (rótulo do filtro comum). */
  periodo?: string
  /** Linhas extras (critério de data, aviso de dado estimado). */
  notas?: string[]
}

/**
 * Legenda de gráfico do Dashboard (L13, §0: "cada gráfico possui título, unidade, legenda e
 * os mesmos filtros de período"): unidade, período e o critério que pôs cada reserva nele.
 * Só texto — nenhum número é calculado aqui.
 */
export const LegendaGrafico: FC<LegendaGraficoProps> = ({ unidade, periodo, notas = [] }) => (
  <Box data-testid="legenda-grafico" sx={{ mt: 1.5 }}>
    <Typography variant="caption" component="div" sx={{ color: tokens.textSecondary }}>
      <strong>Unidade:</strong> {unidade}
      {periodo && (
        <>
          {' · '}
          <strong>Período:</strong> {periodo}
        </>
      )}
    </Typography>
    {notas.map((n) => (
      <Typography key={n} variant="caption" component="div" sx={{ color: tokens.textSecondary }}>
        {n}
      </Typography>
    ))}
  </Box>
)

export default LegendaGrafico
